import { Spinner } from 'react-bootstrap'

const Loader = () => {
    return (
        <>
            <Spinner animation="border" size="sm" />
        </>
    )
}

export default Loader